// Close Popup When Click On Outside

attachEvent('[data-close-modal]', 'click', (ev) => {
  toggleModal(ev.target, false);
});

// Find Store Modal Trigger
attachEvent('[data-find-store-modal-trigger], [data-modal-trigger]', 'click', (ev) => {
  toggleModal(ev.target, true);
  ev.preventDefault();
});
